export const VIDEO_INPUT = 'videoinput'
export const AUDIO_INPUT = 'audioinput'
export const AUDIO_OUTPUT = 'audiooutput'

export enum MediaDevice2Media {
  videoinput = 'video',
  audioinput = 'audio',
  audiooutput = 'audio'
}
